import { render, staticRenderFns } from "./ScopesList.vue?vue&type=template&id=3421e681&scoped=true"
import script from "./ScopesList.vue?vue&type=script&lang=js"
export * from "./ScopesList.vue?vue&type=script&lang=js"
import style0 from "../IsoTemplates.scss?vue&type=style&index=0&id=3421e681&prod&lang=scss&scoped=true&external"
import style1 from "./ScopesList.vue?vue&type=style&index=1&id=3421e681&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3421e681",
  null
  
)

export default component.exports